/* eslint-disable react/prop-types */
import React, { forwardRef, useState } from 'react';
import { Form } from 'react-bootstrap';

const EditTutorialForm = forwardRef(({ currentPDF, onSubmit }, ref) => {
  const [titulo, setTitulo] = useState(currentPDF.name);
  const [date, setDate] = useState(new Date(currentPDF.date));
  // eslint-disable-next-line no-unused-vars
  const [filename, setFilename] = useState(currentPDF.name);
  const [file, setFile] = useState(null);

  const handleEditSubmit = e => {
    e.preventDefault();
    if (!titulo || !file) {
      alert('Ambos campos son requeridos.');
      return;
    }

    const formData = new FormData();
    formData.append('title', titulo);
    formData.append('file', file);
    onSubmit(formData);
  };

  const handleDateChange = e => setDate(new Date(e.target.value));

  const handleFileChange = e => {
    if (e.target.files.length > 0) {
      setFile(e.target.files[0]);
      setFilename(e.target.files[0].name);
    }
  };

  return (
    <Form ref={ref} onSubmit={handleEditSubmit}>
      <Form.Group>
        <Form.Label>Título</Form.Label>
        <Form.Control
          type="text"
          value={titulo} // <- Establece el valor del campo con el estado 'titulo'
          onChange={e => setTitulo(e.target.value)} // <- Manejador para actualizar el estado 'titulo'
          placeholder="Ingrese el título del PDF"
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Fecha de edición</Form.Label>
        <Form.Control
          type="date"
          value={date.toISOString().split('T')[0]} // Convertir la fecha a formato 'YYYY-MM-DD'
          onChange={handleDateChange}
        />

        <Form.Text className="text-muted">Archivo actual: {filename}</Form.Text>
      </Form.Group>
      <Form.Group>
        <Form.Label>Cargar nuevo PDF</Form.Label>
        <Form.Control type="file" onChange={handleFileChange} accept=".pdf" />
      </Form.Group>
    </Form>
  );
});

export default EditTutorialForm;
